<template>
  <AppForm label="配信先設定">
    <div v-if="whiteListItems.length > 0" class="inventory-lists">
      <h4 class="pt-2 subheading grey--text text--darken-2">ホワイトリスト</h4>
      <div>
        <div>必須設定</div>
        <div>
          <v-chip
            v-for="(item, index) in whiteListItems"
            :key="index"
            outline
            >{{ item.name }}</v-chip
          >
        </div>
      </div>
    </div>
    <div class="inventory-lists">
      <h4 class="pt-2 subheading grey--text text--darken-2">ブラックリスト</h4>
      <div v-if="blackListRequiredItems.length > 0">
        <div>必須設定</div>
        <div>
          <v-chip
            v-for="(item, index) in blackListRequiredItems"
            :key="index"
            outline
            >{{ item.name }}</v-chip
          >
        </div>
      </div>
      <div>
        <div>
          任意設定
          <v-btn @click="isActiveEditForm = true">変更</v-btn>
        </div>
        <div>
          <v-chip
            v-for="(item, index) in selectedBlackListOptionalItems"
            :key="index"
            @input="remove(item)"
            :close="true"
            outline
            >{{ item.name }}</v-chip
          >
        </div>
      </div>
    </div>
    <EditModal
      v-model="isActiveEditForm"
      :list="value"
      :inventory-lists-all="blackListOptionalItems"
      @change="change($event)"
    />
  </AppForm>
</template>

<script>
import EditModal from './CampaignModalPageAdvancedInventoryTargetingModalEdit'

export default {
  components: { EditModal },
  props: {
    value: {
      // idの配列
      type: Array,
      default: () => [],
    },
    inventoryRequiredLists: {
      type: Object,
      default: () => {
        return JSON.parse({
          whiteListItems: [],
          blackListItems: [],
        })
      },
    },
    inventoryOptionalLists: {
      type: Object,
      default: () => {
        return JSON.parse({
          whiteListItems: [],
          blackListItems: [],
        })
      },
    },
  },
  data() {
    return {
      isActiveEditForm: false,
    }
  },
  computed: {
    whiteListItems() {
      return this.inventoryRequiredLists.whiteListItems
    },
    blackListRequiredItems() {
      return this.inventoryRequiredLists.blackListItems
    },
    blackListOptionalItems() {
      return this.inventoryOptionalLists.blackListItems
    },
    selectedBlackListOptionalItems() {
      return this.blackListOptionalItems.filter(item => {
        return this.value.indexOf(item.id) > -1
      })
    },
  },
  methods: {
    remove(item) {
      const resultList = this.value.filter(v => v !== item.id)
      this.$emit('input', resultList)
    },
    change(result) {
      this.$emit('input', result)
    },
  },
}
</script>

<style lang="scss">
.inventory-lists {
  margin: 0 0 20px 0;
  > div {
    margin: 20px 0 0 40px;
  }
}
</style>
